import services from './../../../services/service'; // Service Class
import Preset from './../../../mixins/preset.js'; //preset
import SecondHeader from './../../Second-Header/index.vue'; // Second Header
import HorizontalWidget from '../../HorizontalWidget.vue'; // HorizontalWidget
import Sidebar from './../../Sidebar/index.vue'; // Sidebar
import MainFooter from './../../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../../SearchBar.vue'; // Search Bar

let service = new services();

export default {
    name: 'CNdiscounts',
    mixins: [Preset],
    data () {
        return {
            user: {},
            cndiscounts:{},
            cndiscount:{},
            cndiscount_prev:{},
            cndiscount_next:{},
            downloading:false,
            businesses: {},
            business: {},
            cnsurveys: {},
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            page_data: {},
            pag_intv: service.pageIntv,
            reviews: {},
            review: {},
            rate: "",
            has_reviewed: false,
            has_rated: false,
            current_page: 0,
            search_mode: false,
            siteUrl: service.siteShareUrl,
            data_share_link:'',
            loading:true,
        }
    },
    components: {
        'second-header': SecondHeader,
        'horizontal-widget': HorizontalWidget,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                if(this.user.user_id != null){
                    this.rate = newVal;
                    this.rateBusiness();
                }else{
                    localStorage.setItem("cn_prv_page","businesses");//log current page
                    this.preset();
                }
                
                
            }
        }
    },
    methods: {
        copyLink() {
            this.$clipboard(this.siteUrl+this.data_share_link)
              var btn = $('.linky').tooltip({
                  trigger: 'click',
                  placement: 'bottom'
                });
              this.setTooltip(btn, 'Copied to Clipboard');
              this.hideTooltip(btn);
        },
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
        closeModal(modal){
            $(modal).modal("hide");$('#paywith').modal();
        },
        openModal(modal){
            $('#moda').modal();
        },
        
        setCNdiscount(cndiscount,index){
            this.cndiscount = cndiscount;
            //def
            this.cndiscount_prev = this.cndiscounts[index-1];
            this.cndiscount_next = this.cndiscounts[index+1];
            if(index == 0){
                this.cndiscount_prev = {};
            }else{
                this.cndiscount_prev = this.cndiscounts[index-1];
            }
            if((index+1) == this.cndiscounts.length){
                this.cndiscount_next = {};
            }else{
                this.cndiscount_next = this.cndiscounts[index+1];
            }
        },

        getCNdiscount() {
            if(this.$route.params.cndiscountref){
                let str_rs = this.$route.params.cndiscountref;
                var res = str_rs.split("-");
                var listing = res[1];
                this.data_share_link = '?cndiscount='+listing;
                let navi = this.$router;
                service.getCNdiscount(this,listing).then(data => {
                    if(data.body.status == 200) {
                        this.cndiscount = data.body.data[0];
                        this.loading = false;
                        // this.jumpToView('topp03');
                        // this.initMap();
                    }
                }).catch((err) => {
                    if(err) {
                        //toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }
        },

        set_cndiscount_image(cnd){
            let image = '/static/assets/img/cndiscount00.jpg';
            if((cnd.cndiscount_media && ((cnd.cndiscount_media != '')&&(cnd.cndiscount_media != 'business-default.jpg')))){
                image = this.img_url + cnd.cndiscount_media;
            }
            return image
        },

        saveDiv(divId, title) {
            this.downloading = true;
            console.log(this.downloading)
            var d_divId = document.getElementById(divId);
            var d_position = d_divId.getBoundingClientRect();
            var HTML_Width = d_position.width; 
            var HTML_Height = d_position.height; 

            var element = document.getElementById(divId);
            var opt = {
                margin:      1,//[-3, 1, 2, 1],// 1,
                filename:     title+'.pdf',
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2 },
                // jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
                jsPDF:        { unit: 'mm', format: 'letter', orientation: 'portrait' }

             
            };

            // New Promise-based usage:
            html2pdf().set(opt).from(element).save();
            //  var d_divId = document.getElementById(divId);
            let self = this;
            setTimeout(function (){
                self.downloading = false;
            }, 10000);

        },

     
        
        printDiv(divId,title) {

            let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

            mywindow.document.write(`<html><head><title>${title}</title>`);
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(divId).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            return true;
        },

        //
        // initMap() {console.log(98); console.log(document.getElementById("map01"))
        //     // The location of cn
        //     // const cn = { lat: -25.344, lng: 131.036 };
        //     const cn = {lat: 8.985714, lng: 7.4465517}
        //     // The map, centered at cn
        //     const map = new google.maps.Map(document.getElementById("map01"), {
        //         zoom: 10,
        //         center: cn,
        //     });console.log(981); console.log(map)
        //     // The marker, positioned at cn
        //     const marker = new google.maps.Marker({
        //         position: cn,
        //         map: map,
        //     });
        // },


    },
    mounted: function(){
        document.getElementById('topp03').scrollIntoView();
        // this.initMap()
    },
    created: function(){
        // document.getElementById('topp03').scrollIntoView();
        // this.jumpToView('topp03')
        this.getCNdiscount();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNdiscountSystem/CNdiscountPost/script.js